import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class TraitObserved {
  @Expose()
  traitObservedId: number;

  @Expose()
  animalId: number;

  @Expose()
  sex: number;

  @Expose()
  dropyear: number;

  @Expose()
  trait: string;

  @Expose()
  shortCode: string;

  @Expose()
  observed: boolean;

  @Expose()
  progCount: number;
}
